import {
  Box,
  Card,
  CardContent,
  Typography,
  Radio,
  Avatar,
  AvatarGroup,
  Button,
  IconButton,
} from '@mui/material';
import {
  LocationOn,
} from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { ActiveHeartIcon, NonActiveHeartIcon } from '../../../icons';
import useSocket from '../../../hooks/useSocket';
import { memberActionUpdateAPI } from '../../../api/user';
const imgPhoto = "figma:asset/050307847873b3012857291c204136fbe0f049c9.png";

const BotCard = ({ bot, selected, onClick, onBotViewButtonClick, selectedUserId }) => {
  const like =
    bot?.activityLogs?.find(
      log => log.action === "LIKE" && log.userId === selectedUserId
    ) || bot?.isLiked
      ? true
      : false;

  const [isLiked, setIsLiked] = useState(like);
  const { socket } = useSocket();
  const defaultAvatar =
    bot.gender?.toLowerCase() === "female"
      ? "/assets/images/user-profile/woman-avatar.svg"
      : bot.gender?.toLowerCase() === "male"
        ? "/assets/images/user-profile/man-avatar.svg"
        : "/assets/images/user-profile/default-avatar.svg";
  // Determine if we should show multiple avatars or single avatar
  const shouldShowMultipleAvatars = bot.images && bot.images.length > 1;
  const toggleFavorite = async (e) => {
    e.stopPropagation();
    const actionType = isLiked ? 'UNLIKE' : 'LIKE';
    await memberActionUpdateAPI({
      memberId: selectedUserId,
      data: {
        action: actionType,
        targetUserId: bot.userId
      }
    })
    setTimeout(() => {
      if (socket && actionType === "LIKE") {
        socket.emit("profileActivity", {
          userId: selectedUserId,
          targetUserId: bot.userId,
          action: "like"
        });
      }
    }, 1000);
    setIsLiked(!isLiked);
  };
  const handleBotViewButtonClick = (e) => {
    e.stopPropagation();
    onBotViewButtonClick(bot);
  };
  useEffect(() => {
    const liked =
      bot.activityLogs.some(
        log => log.action === "LIKE" && log.userId === selectedUserId
      ) || bot?.isLiked;

    setIsLiked(Boolean(liked));
  }, [bot, selectedUserId]);
  return (
    <Card
      sx={{
        borderRadius: 2,
        border: '1px solid',
        borderColor: selected ? '#BF8500' : '#E5E7EB',
        backgroundColor: selected ? 'rgba(191, 133, 0, 0.05)' : 'white',
        boxShadow: selected ? '0px 4px 6px -1px rgba(191, 133, 0, 0.1)' : 'none',
        cursor: 'pointer',
        transition: 'all 0.2s',
        '&:hover': {
          borderColor: selected ? '#BF8500' : 'grey.300',
        },
        mb: 1
      }}
      onClick={() => onClick && onClick({ ...bot, isLiked })}
    >
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {/* Radio Button */}
          <Radio
            checked={selected}
            sx={{
              color: selected ? '#BF8500' : 'grey.400',
              '&.Mui-checked': {
                color: '#BF8500',
              },
            }}
          />

          {/* Avatar with status */}
          <Box sx={{ position: 'relative' }}>
            {shouldShowMultipleAvatars ? (
              <AvatarGroup max={3} sx={{ '& .MuiAvatar-root': { width: 32, height: 32 } }}>
                <Avatar src={imgPhoto} />
                {bot.images.map((img, index) => (
                  <Avatar key={index} src={img} />
                ))}
              </AvatarGroup>
            ) : (
                <img
                  src={bot.profilePicture || defaultAvatar}
                  alt={bot.firstName ?? bot.userName}
                  style={{ width: 72, height: 72, borderRadius: '50%', objectFit: 'cover' }}
              />
                //   <Avatar
                //     src={bot.profilePicture || defaultAvatar}
                //   sx={{ width: 40, height: 40 }}
                // />
            )}
            {bot.isOnLine && (
              <Box
                sx={{
                  position: 'absolute',
                  bottom: -2,
                  right: -2,
                  width: 12,
                  height: 12,
                  bgcolor: 'success.main',
                  borderRadius: '50%',
                  border: '2px solid white'
                }}
              />
            )}
          </Box>

          {/* Bot Info */}
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontSize: '16px', fontWeight: '500', color: '#3C4043',textTransform:'capitalize' }}>
              {bot.firstName ?? bot?.userName}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <LocationOn sx={{ fontSize: 14, color: 'text.secondary' }} />
              <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'Neue Montreal, sans-serif' }}>
                {`${bot?.distance?.toFixed(0)} KM ${bot.city}, ${bot.country}`}
              </Typography>
            </Box>
          </Box>

          {/* Heart Icon */}
          <IconButton size="small" onClick={(e) => toggleFavorite(e)}>
            <IconButton size="small" onClick={toggleFavorite}>
              {isLiked ? (
                <ActiveHeartIcon style={{ width: 30, height: 30 }} />
              ) : (
                <NonActiveHeartIcon style={{ width: 30, height: 30 }} />
              )}
            </IconButton>
          </IconButton>
          <Button onClick={(e) => handleBotViewButtonClick(e)} sx={{ textTransform: 'capitalize', fontSize: '12px', background: '#BE1F1F', color: '#fff', borderRadius: '20px', px: 2, '&:hover': { background: '#ff4A4A' } }}>View Profile</Button>

        </Box>
      </CardContent>
    </Card>
  );
};

export default BotCard;